import React from 'react';
import { Badge } from '@cvent/carina/components/Badge';
import { useAttendeeMessaging } from '@context/AttendeeMessagingContext';
import { useTranslate } from 'nucleus-text';

import { injectTestId } from '@cvent/nucleus-test-automation';

function MessageBadge(): JSX.Element {
  const { translate } = useTranslate();
  const { unreadCount } = useAttendeeMessaging();

  if (!unreadCount) return null;

  const count = unreadCount > 99 ? translate('AttendeeMessaging-UnreadMessages-99') : `${unreadCount}`;
  return <Badge content={count} {...injectTestId('attendee-messaging-badge')} variant="danger" />;
}

export default React.memo(MessageBadge);
